import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ProfileImageHandler from './ProfileImageHandler';
import i18n from '../../../../shared/locales/no.json';
import ProfileLogo from '../../../components/employerProfile/ProfileLogo';

class EditableLogo extends Component {
    static propTypes = {
        loading: PropTypes.bool,
        profile: PropTypes.shape({
            id: PropTypes.number.isRequired,
            logo: PropTypes.string,
        }).isRequired,
        uploadLogo: PropTypes.func.isRequired,
    };

    render() {
        return (
            <ProfileLogo
                altText={`${this.props.profile.companyName} logo`}
                logo={this.props.profile.logo}
            >
                <ProfileImageHandler
                    classes="button button--small"
                    fieldName="logo"
                    loading={this.props.loading}
                    profileId={this.props.profile.id}
                    uploadBackground={this.props.uploadLogo}
                >
                    <span>{i18n['Change logo']}</span>
                </ProfileImageHandler>
            </ProfileLogo>
        );
    }
}

export default EditableLogo;
